<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("routes.council_members") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="showDialog">
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <global-search-filter :queries="queries" ref="search_filter_ref" />
    <v-row no-gutters>
      <v-col cols="12" sm="2" class="toggle-spacing toggle-adjust">
        <global-toggle-filter
          :queries="toggleQueryies"
          ref="toggle_filter_ref"
          class="mt-2"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn large @click="ClearAllFilters" class="error">{{
          $t("button.reset")
        }}</v-btn>
      </v-col>
    </v-row>
    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="20"
      :loading="tableLoading"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <td class="text-sm-center">
            <v-avatar size="40">
              <v-img
                @click="showImagePreview(item.main_image)"
                class="hover-pointer"
                aspect-ratio="1"
                :src="
                  item.main_image
                    ? item.main_image.path
                    : require('@/assets/imgs/user.png')
                "
              ></v-img>
            </v-avatar>
          </td>
          <td class="text-sm-center">{{ item.name }}</td>
          <td class="text-sm-center">{{ item.position }}</td>
          <td class="text-sm-center" :title="item.bio">
            {{ item.bio | truncate }}
          </td>
          <td class="toggle-spacing text-center">
            <toggle-service
              :is-edit="true"
              model-name="members"
              :model-id="item.id"
              field="visible"
              v-model="item.visible"
              :validate="true"
            />
          </td>
          <td class="text-sm-center">{{ item.priority }}</td>

          <td class="text-sm-center">
            <v-icon small title="edit" @click="handleEdit(item, index)">
              mdi-pencil</v-icon
            >
            <v-icon small title="delete" @click="handleDelete(item, index)">
              mdi-delete</v-icon
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- table -->
    <!-- dialog -->
    <DialogComponent v-model="dialog" @close_dialog="dialog = !dialog">
      <template #heading>
        <v-card-title>{{ dialogTitle }}</v-card-title>
      </template>
      <template #body>
        <form-component
          :dialog="dialog"
          @click="dialog = false"
          @close_dialog="dialog = false"
          @set_memeber="handleSetMember"
          @set_edited_member="handleEditedMember"
          @toggleEdit="isEdit = false"
          @set_refresh="handleGetMembers"
          :isEdited="isEdit"
          :slug="slug"
          @update_main_image="handleUpdateImage"
        />
      </template>
    </DialogComponent>
    <!-- dialog -->

    <!-- Image Preview -->
    <global-image-preview
      :showDialog="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
    <!-- Image Preview -->
  </div>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, DeleteData } from "@/helpers/apiMethods";
export default {
  name: "Memebers",
  components: {
    FormComponent: () => import("./formComponent"),
    DialogComponent: () => import("@/components/DialogComponent"),
  },
  data() {
    return {
      slug: "",
      headers: [],
      items: [],
      tableLoading: true,
      dialog: false,
      isEdit: false,
      imageOverlay: false,
      currentPreviewImage: "",
      itemIndex: "",
      queries: {
        query: {
          name: "",
        },
      },
      toggleQueryies: {
        query: {
          visible: "",
        },
      },
    };
  },
  computed: {
    dialogTitle() {
      if (this.isEdit) {
        return this.$t("headings.edit");
      } else {
        return this.$t("headings.create");
      }
    },
  },

  mounted() {
    this.createTableHeaders();
  },
  methods: {
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    },
    handleUpdateImage(image) {
      this.items[this.itemIndex].main_image = image;
      this.items = [...this.items];
    },
    handleEditedMember(member) {
      this.$set(this.items, this.itemIndex, member);
    },
    handleEdit({ slug }, index) {
      this.slug = slug;
      this.itemIndex = index;
      this.dialog = true;
      this.isEdit = true;
    },
    handleDelete({ slug }, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteData({ reqName: "members", param: slug })
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    handleSetMember(item) {
      this.items.push(item);
    },
    createTableHeaders() {
      const headersList = [
        "profile",
        "name",
        "position",
        "bio",
        "visibility",
        "priority",
        "actions",
      ];
      this.headers = TableHeaders(headersList);
    },
    handleGetMembers(query) {
      IndexData({ reqName: "members", query })
        .then((res) => {
          const { data } = res.data;
          this.items = data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    showDialog() {
      this.dialog = !this.dialog;
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.isEdit = false;
        }
      },
      immediate: true,
    },
    $route: {
      handler({ query }) {
        this.handleGetMembers(query);
      },
      immediate: true,
    },
  },
};
</script>
